import { render, staticRenderFns } from "./network.vue?vue&type=template&id=2d0d3c53"
import script from "./network.vue?vue&type=script&lang=js"
export * from "./network.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports